import pages from './pages.js'
export default [
  {
    name: '404',
    path: '/404',
    component: () => pages['404'],
    children: [],
    meta: { hidden: false }
  },
  {
    name: 'Excel',
    path: '/Excel',
    component: () => pages['Excel'],
    children: [],
    meta: { hidden: false }
  },
  {
    name: 'FeishuLogin',
    path: '/FeishuLogin',
    component: () => pages['FeishuLogin'],
    children: [],
    meta: { hidden: false }
  },
  {
    name: 'Home',
    path: '/Home',
    component: () => pages['Home'],
    children: [],
    meta: { hidden: false }
  },
  {
    name: 'Iframe',
    path: '/Iframe',
    component: () => pages['Iframe'],
    children: [],
    meta: { hidden: false }
  },
  {
    name: 'ImportGira',
    path: '/ImportGira',
    component: () => pages['ImportGira'],
    children: [],
    meta: { hidden: false }
  },
  {
    name: 'Language',
    path: '/Language',
    component: () => pages['Language'],
    children: [
      {
        name: 'List',
        path: 'List',
        component: () => pages['Language-List'],
        children: [],
        meta: { hidden: false }
      },
      {
        name: 'Setting',
        path: 'Setting',
        component: () => pages['Language-Setting'],
        children: [],
        meta: { hidden: false }
      }
    ],
    meta: { hidden: false }
  },
  {
    name: 'Login',
    path: '/Login',
    component: () => pages['Login'],
    children: [],
    meta: { hidden: false }
  },
  {
    name: 'Message',
    path: '/Message',
    component: () => pages['Message'],
    children: [],
    meta: { hidden: false }
  },
  {
    name: 'MicroApplication',
    path: '/MicroApplication',
    component: () => pages['MicroApplication'],
    children: [],
    meta: { hidden: false }
  },
  {
    name: 'NoticePublishCenter',
    path: '/NoticePublishCenter',
    component: () => pages['NoticePublishCenter'],
    children: [],
    meta: { hidden: false }
  },
  {
    name: 'NoticePublishConfig',
    path: '/NoticePublishConfig',
    component: () => pages['NoticePublishConfig'],
    children: [],
    meta: { hidden: false }
  },
  {
    name: 'StaffLetter',
    path: '/StaffLetter',
    component: () => pages['StaffLetter'],
    children: [],
    meta: { hidden: false }
  },
  {
    name: 'System',
    path: '/System',
    component: () => pages['System'],
    children: [
      {
        name: 'AccountManage',
        path: 'AccountManage',
        component: () => pages['System-AccountManage'],
        children: [],
        meta: { hidden: false }
      },
      {
        name: 'MenuManage',
        path: 'MenuManage',
        component: () => pages['System-MenuManage'],
        children: [],
        meta: { hidden: false }
      },
      {
        name: 'MenuRegistration',
        path: 'MenuRegistration',
        component: () => pages['System-MenuRegistration'],
        children: [],
        meta: { hidden: false }
      },
      {
        name: 'PersonalManage',
        path: 'PersonalManage',
        component: () => pages['System-PersonalManage'],
        children: [],
        meta: { hidden: false }
      },
      {
        name: 'RoleManage',
        path: 'RoleManage',
        component: () => pages['System-RoleManage'],
        children: [],
        meta: { hidden: false }
      }
    ],
    meta: { hidden: false }
  },
  {
    name: 'SystemList',
    path: '/SystemList',
    component: () => pages['SystemList'],
    children: [],
    meta: { hidden: false }
  },
  {
    name: 'WorkBench',
    path: '/WorkBench',
    component: () => pages['WorkBench'],
    children: [],
    meta: { hidden: false }
  },
  {
    name: 'WorkManager',
    path: '/WorkManager',
    component: () => pages['WorkManager'],
    children: [],
    meta: { hidden: false }
  }
]
